import { useEffect, useState } from 'react';

import { ANY_FINE_POINTER_QUERY, COARSE_POINTER_QUERY, isHoverSupportedDevice } from 'helpers/ClientUtils';

/**
 * Reactive `isHoverSupportedDevice`: re-evaluates on matchMedia `change` (which a
 * resize listener would miss, e.g. toggling DevTools device emulation).
 * SSR-safe: starts `false` and resolves on the client after mount.
 */
export const useCanHover = (): boolean => {
  const [canHover, setCanHover] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const coarse = window.matchMedia(COARSE_POINTER_QUERY);
    const anyFine = window.matchMedia(ANY_FINE_POINTER_QUERY);
    const update = () => setCanHover(isHoverSupportedDevice());

    update();
    coarse.addEventListener?.('change', update);
    anyFine.addEventListener?.('change', update);

    return () => {
      coarse.removeEventListener?.('change', update);
      anyFine.removeEventListener?.('change', update);
    };
  }, []);

  return canHover;
};
